import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import { Assessment, Star, School } from '@material-ui/icons';

import { Card } from 'components/Toolbar/';
import { ReportCompanyData } from 'services/dataService';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();
  const [summary, setSummary] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ReportCompanyData.getRatingsReport({
          page: 1,
          limit: 1,
        });
        setSummary(response.data.summary);
      } catch (error) {
        toast.error('Não foi possível buscar o resumo do relatório.');
      }
    };

    fetchData();
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={2} className={classes.overrideWrap}>
        <Grid item md={4} xs={12}>
          <Card
            title="Total de Avaliações"
            number={summary?.total_ratings}
            icon={Assessment}
            iconStyle={classes.blueIcon}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <Card
            title="Média Geral"
            number={summary?.average_rating}
            icon={Star}
            iconStyle={classes.yellowIcon}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <Card
            title="Cursos Avaliados"
            number={summary?.rated_courses_count}
            icon={School}
            iconStyle={classes.greenIcon}
          />
        </Grid>
      </Grid>
    </div>
  );
};
